module.exports = __webpack_public_path__ + "static/img/xnq1009.76efdbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xnq1009.jpg
// module id = 8oRq
// module chunks = 0